<form [formGroup]="paymentForm" class="p-4" style="width: 500px">
  <div class="ks-row">
    <div class="ks-w-100">
      <kt-input
        [type]="'text'"
        [label]="'Office'"
        [readonly]="'true'"
        [control]="getFormControl('office')"
        [errors]="[{ validation: 'required', message: 'Office is required to proceed' }]"
      ></kt-input>
    </div>
  </div>
  <div class="ks-row">
    <div class="ks-w-100">
      <kt-autocomplete
        [control]="getFormControl('entities')"
        [optionsType]="'LIST'"
        [label]="'Entities'"
        [placeholder]="'Select Entity'"
        [options]="entitiesOptions"
        [optionType]="'OBJECT'"
        [objectOptionReq]="{
          idKey: 'id',
          dataPath: 'data',
          labelFormatter: formatEntity,
          valueFormatter: formatEntity
        }"
        [errors]="[{ validation: 'required', message: 'Entity is required to proceed' }]"
      ></kt-autocomplete>
    </div>
  </div>
  <div class="ks-row">
    <div class="ks-w-100">
      <kt-autocomplete
        [control]="getFormControl('financialContact')"
        [optionsType]="'LIST'"
        [label]="'Financial Contact'"
        [placeholder]="'Select Financial Contact'"
        [options]="financialOptions"
        [optionType]="'OBJECT'"
        [objectOptionReq]="{
          idKey: 'contactUUID',
          dataPath: 'data',
          labelFormatter: formatFinancialContact,
          valueFormatter: formatFinancialContact
        }"
        [errors]="[{ validation: 'required', message: 'Financial Contact is required to proceed' }]"
      ></kt-autocomplete>
    </div>
  </div>
  <div class="ks-row">
    <div class="ks-w-100">
      <kt-input
        [type]="'number'"
        [label]="'Amount'"
        [control]="getFormControl('amount')"
        [errors]="[{ validation: 'required', message: 'Amount  is required to proceed' }]"
      ></kt-input>
    </div>
  </div>
</form>
